import type { ISupabaseApi, SupabaseEntity } from './AbstractSupabaseApi';
import { type Suggestion, suggestionApi } from './suggestion.api';

export interface ISupabaseService<T extends SupabaseEntity> {
	api: ISupabaseApi<T>;
	_create: (dto: T['Insert']) => void;
}

class SuggestionService implements ISupabaseService<Suggestion> {
	api = suggestionApi;
	TABLE_NAME = 'suggestion';

	_create = async (dto: Suggestion['Insert']) => {
		return this.api.create(dto);
	};

	create = async (dto: Suggestion['Insert']) => await this._create(dto);
}
export const suggestionService = new SuggestionService();
